<template>
	<div>
		<v-menu rounded="lg" bottom left :minWidth="720" :maxWidth="720" offset-y dense :close-on-content-click="false">
			<template v-slot:activator="{ on, attrs, value }">
				<div v-bind="attrs" v-on="on">
					<AppTooltip :disabled="value" position="bottom" text="Click to see permission details">
						<SIcon name="installation-tab-info" width="12" height="18" />
					</AppTooltip>
				</div>
			</template>
			<div class="content-container flex-justify-space-between display-flex flex-column width-100 pa-5">
				<div>
					<div class="info-title-text mb-3">This is {{ isPersonal ? 'your personal' : 'a workspace' }} space</div>
					<ul>
						<li v-for="explanation in explanations" :key="explanation">{{ explanation }}</li>
					</ul>
				</div>
			</div>
		</v-menu>
	</div>
</template>

<script>
export default {
	name: 'ProjectMenuSectionInfo',
	props: {
		isPersonal: { type: Boolean },
	},
	computed: {
		explanations() {
			return this.isPersonal ? this.personalExplanations : this.workspaceExplanations;
		},
	},
	methods: {},
	data() {
		return {
			workspaceExplanations: [
				'Space collaborators have edit, share and analyze access, based on space permissions.',
				'You can give use-access permission to other workspace members.',
				'Workspace admins have full access.',
			],
			personalExplanations: [
				'Only you can create, edit, use and share features and connections.',
				'You can give use-access permission to other workspace members.',
				'Workspace admins have read-only access - they can see and disable your features, connections and task log, but cannot edit, share or use them.',
			],
		};
	},
};
</script>

<style scoped lang="scss">
.content-container {
	height: 160px;
	font-size: 14px;
	color: #4d4c52;
	background: var(--white);
}
.info-title-text {
	font-weight: 500;
}
.link {
	width: 80px;
	color: #4d4c52;
	text-decoration: underline;
}
</style>
